import React from 'react'
import PropTypes from 'prop-types'

export default function LayerOrder(props) {
  return (
    <svg width={20} height={20} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M12 2L2 7L12 12L22 7L12 2ZM12 4.24L18.47 7L12 9.76L5.53 7L12 4.24Z"
        fill={props.color || '#8E8E92'}
      />
      <path d="M2 12L12 17L22 12L20.09 11.05L12 15.09L3.91 11.05L2 12Z" fill={props.color || '#8E8E92'} />
      <path d="M2 17L12 22L22 17L20.09 16.05L12 20.09L3.91 16.05L2 17Z" fill={props.color || '#8E8E92'} />
    </svg>
  )
}

LayerOrder.propTypes = {
  color: PropTypes.string
}
